// extracted by mini-css-extract-plugin
module.exports = {"list":"MetaMaskButton_list__2ApK7","icon-button":"MetaMaskButton_icon-button__1YKBc"};